<template>
	<div class="customers-company-details">
		<AppBottomSheet :active="company !== null" :forceWidth="bottomSheetWidth" @toggling-popup="togglingPopup" >
			<div class="company-details-container" v-if="company !== null">
				<div class="sheet-heading">
					<div class="sheet-heading-first-row">
						<div class="row pointer flex-start align-center"
							 :title="getString('go_to_x', [
								 tabIndex === 2 ?
							 		getString('history') :
							 		getString('edit_x', [getString('company')])
							 ])"
							 @click="switchedTab"
						>
							<div class="edit-icon" :class="{active: tabIndex === 2}" v-html="svgStore.get('iconEdit')"></div>
							<p class="sheet-title">{{company?.name}}</p>
						</div>
						<div class="row flex-end first-row-ctas">
							<div class="print-icon-container pointer" @click.stop="printCustomerCreditQr">
								<div class="print-icon" v-html="svgStore.get('iconPrinter')"></div>
							</div>
							<AppButton :small="windowWidth < 600" outline :text="mainCtaText" @click.stop="tabButtonAction" />
						</div>
					</div>
					<div class="row centered credit-display-container">
						<div class="col-6 mobile-12 credit-display centered debit" @click="tabIndex = 0" :title="getString('go_to_x', [getString('history')])">
							<div class="row centered"><p class="balance-label">{{getString('debit_x', [currencyStore.currCurrency.symbol])}}</p></div>
							<div class="row centered">
								<p class="balance-value">
									-{{currencyStore.readableCurrencyValue(company?.debit, true, false)}}
								</p>
							</div>
						</div>
						<div :class="{animating: animatingCredit}" class="col-6 mobile-12 credit-display centered credit" @click="tabIndex = 3" :title="getString('go_to_x', [getString('topups')])">
							<div class="row centered"><p class="balance-label">{{getString('credit_x', [currencyStore.currCurrency.symbol])}}</p></div>
							<div class="row centered">
								<p class="balance-value">
									+{{customerCredit}}
								</p>
							</div>
						</div>
					</div>
				</div>
				<AppTabsSwitch v-show="tabIndex !== 2 && tabIndex !== 3" class="mb-14" :active-item="tabIndex" :items="[getString('history'), getString('people')]" @switched="i => tabIndex = i" />
				<div class="tabs-container">
					<div class="orders-container" v-if="tabIndex === 3">
						<div class="tabs-container">
							<AppTable
								ref="topups-table"
								:fetch-function="fetchFunctionCompanyCreditTopups"
								:table-headings="topupsTableHeadings"
								:filters="topupsFilters"
								:total-items="customersStore.companyCreditTopupsTotal"
								:items="topupsToShow"
								initial-sort-field="date"
							>
								<template #custom-header>
									<h3>{{getString('topups')}}</h3>
								</template>
							</AppTable>
						</div>
					</div>
					<div class="orders-container" v-else-if="tabIndex === 0">
						<div class="tabs-container">
							<AppTable
								ref="orders-table"
								:fetch-function="fetchFunctionCompanyOrdersPayments"
								:table-headings="tableHeadings"
								:filters="filters"
								:total-items="customersStore.companyOrdersTotal"
								:items="ordersToShow"
								initial-sort-field="date">
								<template #custom-header>
									<h3>{{getString('history')}}</h3>
									<div>
										<AppButton small outline :text="payButtonText" @click="openBottomPayment" :disabled="cartButtonDisabled" />
									</div>
								</template>
								<template #settingsIcon="{item}">
									<div class="row centered">
										<AppTableButtonGroup v-if="item.type === 'paylater'" :buttons="buttonsPay(item)" :item="item" @picked-pay="addToCart(item)"/>
										<p v-else> - </p>
									</div>
								</template>
								<template #order_number="{item}">
									<div class="row centered">
										<p class="payment-intent" :class="{clickable: !!item.order_id}" @click="goToOrder(item.order_id)">{{ item.order_number }}</p>
									</div>
								</template>
							</AppTable>
						</div>
					</div>
					<div class="people-container" v-else-if="tabIndex === 1">
						<AppTable
							ref="people-table"
							:fetch-function="fetchFunctionCompanyPeople"
							:table-headings="tableHeadingsPeople"
							:total-items="customersStore.companyPeopleTotal"
							:filters="peopleFilters"
							:items="peopleToShow"
						>
							<template #custom-header>
								<div class="sheet-heading-first-row">
									<div class="row pointer flex-start align-center">
										<h3>{{getString('people')}}</h3>
									</div>
									<div class="row flex-end first-row-ctas">
										<div class="print-icon-container">
											<AppButton icon-left="icon-pointer-hand" small outline @click="customersPickerActive = true" :text="getString('associate_person')" />
										</div>
										<AppButton small outline :text="payButtonText" @click="openBottomPayment" :disabled="cartButtonDisabled" />
									</div>
								</div>
							</template>
							<template #settingsIcon="{item, heading}">
								<div class="row centered">
									<AppTableButtonGroup v-if="item.debit > 0" :buttons="buttonsPayPerson(item)" :item="item" @picked-pay-person="addToPeopleCart(item)"/>
									<div v-else class="table-text">-</div>
								</div>
							</template>
							<template #removeIcon="{item, heading}">
								<div class="row centered">
									<AppTableButtonGroup :buttons="buttonsDelete" :item="item" @picked-delete="removeCustomerAssociation(item)"/>
								</div>
							</template>
						</AppTable>
					</div>
					<div class="details-container" v-else-if="tabIndex === 2">
						<AppCard class="details-card" :title="getString('edit_x', [getString('company')])">
							<template v-slot:body>
								<CustomersCompanyEditDetails @deleted-company="emitDeletedCompany" ref="company-details" :company-id="companyId" />
							</template>
						</AppCard>
					</div>
				</div>
			</div>
		</AppBottomSheet>
		<CustomersPicker :active="customersPickerActive" people-only @toggling-popup="togglingPopupPicker" @picked-customer="associateCustomer" />
		<BottomNumberEditor
			:active="activeAddCreditNumberEditor"
			:title="getString('add_credit')"
			:starting-number="company?.credit || 0"
			:start-price-name="getString('current_balance')"
			:discount-name="getString('adding_credit')"
			:total-name="getString('updated_balance')"
			no-actions
			show-all-shortcuts
			custom-shortcuts
			only-increment
			@toggling-popup="togglingCreditNumberEditor"
			@confirm-number="confirmCreditTopUp"
		/>
		<BottomPayment is-registry hide-customer-picker no-pay-later customer-not-editable :items-split="null" :active="paymentActive" @toggling-popup="togglingPayment" @payment-done="paymentDone" @deleted-company="emitDeletedCompany" :total="bottomPaymentAmount" :paid-value="0" :skip-tipping="true" />
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppCard from "@/shared/components/AppCard.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore, useSvgStore, useValuesStore} from "@/shared/stores";
import {useCustomersStore, useCounterStore, useOrdersStore, useUserStore, useNativeStore} from "@/console-new/stores";
import AppSelect from "@/shared/components/AppSelect.vue";
import AppGoogleMapsInput from "@/shared/components/AppGoogleMapsInput.vue";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import {formatDateTime, formatDateYYMMDD, formatDateMMDDHHmm, formatDateOnly} from "@/shared/helpers/dates";
import AppTabsSwitch from "@/shared/components/AppTabsSwitch.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppTable from "@/shared/components/AppTable.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import API from "@/shared/helpers/API";
import AppButton from "@/shared/components/AppButton.vue";
import CustomersPicker from "@/console-new/components/ops/CustomersPicker.vue";
import BottomPayment from "@/console-new/components/ops/counter/BottomPayment.vue";
import {useSunmiStore} from "@/console-sun/stores";
import CustomersCompanyEditDetails from "@/console-new/components/ops/CustomersCompanyEditDetails.vue";
import CustomersPersonEditDetails from "@/console-new/components/ops/CustomersPersonEditDetails.vue";
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";
import BottomNumberEditor from "@/console-new/components/ops/counter/BottomNumberEditor.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const customersStore = useCustomersStore();
		const ordersStore = useOrdersStore();
		const valuesStore = useValuesStore();
		const currencyStore = useCurrencyStore();
		const counterStore = useCounterStore();
		const svgStore = useSvgStore();
		const sunmiStore = useSunmiStore();
		const nativeStore = useNativeStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, currencyStore, userStore, customersStore, counterStore, ordersStore, valuesStore, svgStore, sunmiStore, nativeStore, formatDateYYMMDD, formatDateMMDDHHmm, formatDateTime}
	},
	name: "CustomersCompanyDetails",
	components: {
		BottomNumberEditor,
		AppTableButtonGroup,
		AppCard,
		CustomersPersonEditDetails,
		CustomersCompanyEditDetails, BottomPayment, CustomersPicker, AppButton, AppTextInput, AppTable, AppButtonIcon, AppTabsSwitch, AppRadioButtonGroup, AppGoogleMapsInput, AppSelect, ModalHeader, AppBottomSheet},
	mixins: [WindowWidth],
	emits: ['toggling-popup', 'deleted-company'],
	props: {
		companyId: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			cart: [],
			cartPeople: [],
			cartPeopleRealTotal: 0,
			cartPeopleOrderIds: [],
			animatingCredit: false,
			tempCreditValue: 0,
			paymentActive: false,
			customersPickerActive: false,
			activeAddCreditNumberEditor: false,
			topUpCredit: 0,
			toUpdate: false,
			//history: 0, people: 1, details: 2, topups: 3
			tabIndex: 0,
			topupsFilters: [
				{
					type: "price",
					key: "amount",
					text: this.getString("amount"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
				{
					type: "checklist",
					key: "type",
					text: this.getString('payment'),
					values: [
						this.getString('payment_type_stripe'),
						this.getString('payment_type_cash'),
						this.getString('payment_type_satispay'),
						this.getString('payment_type_klarna'),
						this.getString('payment_type_ticket'),
						this.getString('payment_type_check'),
						this.getString('payment_type_wire'),
						this.getString('payment_type_external')
					],
					keysArray: [
						'stripe',
						'cash',
						'satispay',
						'klarna',
						'ticket',
						'check',
						'wire',
						'external'
					],
					active: false,
					selectedIndexes: [],
					finalValue: '',
				},
			],
			topupsTableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
				},
				{
					text: this.getString('amount'),
					cols: 1,
					sortable: true,
					fieldName: 'readable_amount',
					sortFieldName: 'amount',
				},
				{
					text: this.getString('type'),
					cols: 1,
					fieldName: 'readable_type',
				},
			],
			filters: [
				{
					type: "price",
					key: "total",
					text: this.getString("amount"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('id'),
					cols: 1,
					sortable: false,
					fieldName: 'id',
					slotName: 'order_number',
				},
				{
					text: this.getString('type'),
					cols: 1,
					fieldName: 'readable_type',
				},
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
				},
				{
					text: this.getString('amount'),
					cols: 1,
					sortable: true,
					fieldName: 'readable_total',
					sortFieldName: 'amount',
				},
				{
					text: this.getString('actions'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'settingsIcon',
				},
			],
			peopleFilters: [
				{
					type: "price",
					key: "debit",
					text: this.getString("debit"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadingsPeople: [
				{
					text: this.getString('name'),
					cols: 2,
					sortable: true,
					fieldName: 'name',
				},
				{
					text: this.getString('email'),
					cols: 2,
					fieldName: 'email',
				},
				{
					text: this.getString('debit'),
					cols: 1,
					sortable: true,
					fieldName: 'readable_debit',
					sortFieldName: 'debit',
				},
				{
					text: this.getString('actions'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'settingsIcon',
				},
				{
					text: this.getString('remove'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'removeIcon',
				},
			],
		}
	},
	computed: {
		customerCredit() {
			let refValue = this.animatingCredit ? this.tempCreditValue : this.company?.credit;
			return this.currencyStore.readableCurrencyValue(refValue, true, false)
		},
		mainCtaText() {
			return this.getString(this.tabIndex === 2 ? 'save' : 'add_credit');
		},
		company() {
			return this.companyId ? this.customersStore.customersCompanies.find(company => company.customer_id === this.companyId) : null;
		},
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		ordersToShow() {
			return this.customersStore.companyOrders.map(order => {
				return {
					...order,
					readable_total: this.currencyStore.readableCurrencyValue(order.amount),
					readable_type:  this.getString(order.payment_id ? 'payment' : 'order_status_x', [order.type === 'paylater' ? this.getString('not_paid') : this.getString('paid')]),
					date: this.formatDateMMDDHHmm(order.date),
					id: order?.order_number_day ? order.order_number : order.payment_id
				}
			})
		},
		peopleToShow() {
			return this.customersStore.companyPeople.map(person => {
				return {
					...person,
					readable_debit: this.currencyStore.readableCurrencyValue(person.debit),
				}
			})
		},
		topupsToShow() {
			return this.customersStore.companyCreditTopups.map(topup => {
				let readableType = '-';
				if(topup.type) {
					readableType = this.getString('payment_type_' + topup.type) || topup.type;
				}
				return {
					...topup,
					readable_amount: this.currencyStore.readableCurrencyValue(topup.amount),
					readable_type: readableType,
					date: this.formatDateMMDDHHmm(topup.date),
				}
			})
		},
		cartTotal() {
			return this.cart.reduce((acc, curr) => {
				return acc + curr.total
			}, 0);
		},
		cartButtonDisabled() {
			if(!this.userStore.checkAnyOrderPayAllowed){
				return true;
			}

			if(this.tabIndex === 0) {
				return this.cartTotal <= 0;
			} else if(this.tabIndex === 1) {
				return this.cartPeopleTotal <= 0;
			} else {
				return false;
			}
		},
		cartPeopleTotal() {
			return this.cartPeople.reduce((acc, curr) => acc + curr.total, 0);
		},
		bottomPaymentAmount() {
			if(this.activeAddCreditNumberEditor) {
				return this.topUpCredit;
			}
			if(this.tabIndex === 0) {
				return this.cartTotal;
			} else if(this.tabIndex === 1) {
				return this.cartPeopleRealTotal;
			} else {
				return 0;
			}
		},
		buttonsDelete() {
			return [
				{
					iconName: "icon-trash-blue",
					disabled: !this.userStore.checkAnyOrderPayAllowed,
					class: "outline",
					emitName: "picked-delete",
					title: this.getString('delete'),
					active: false
				}
			];
		},
		payButtonText() {
			if(this.tabIndex === 0) {
				if(this.cartTotal > 0) {
					return this.getString('pay_x', [this.currencyStore.readableCurrencyValue(this.cartTotal)]);
				} else {
					return this.getString('pay');
				}
			} else if(this.tabIndex === 1) {
				if(this.cartPeopleTotal > 0) {
					return this.getString('pay_x', [this.currencyStore.readableCurrencyValue(this.cartPeopleTotal)]);
				} else {
					return this.getString('pay');
				}
			}
			return '';

		},
	},
	methods: {
		buttonsPay(order) {
			return [
				{
					emitName: "picked-pay",
					title: this.getString(this.isOrderInCart(order) ? 'in_cart' : 'add'),
					activeFunction: (item) => this.isOrderInCart(item),
					disabled: !this.userStore.checkAnyOrderPayAllowed
				},
			]
		},
		buttonsPayPerson(person) {
			return [
				{
					disabled: !this.userStore.checkAnyOrderPayAllowed,
					emitName: "picked-pay-person",
					title: this.getString(this.isPersonInCart(person) ? 'in_cart' : 'add'),
					activeFunction: (item) => this.isPersonInCart(item),
				},
			]
		},
		switchedTab() {
			this.tabIndex = this.tabIndex === 2 ? 0 : 2;
		},
		togglingPopup(open) {
			this.$emit('toggling-popup', open);
			if(!open) {
				this.tabIndex = 0;
			}
		},
		togglingCreditNumberEditor(active) {
			if(!active) {
				this.activeAddCreditNumberEditor = false;
			}
		},
		confirmCreditTopUp(creditToAdd) {
			let amount = Number(creditToAdd || 0);
			if(amount === 0) {
				this.showNotification('no-changes');
				this.activeAddCreditNumberEditor = false;
			} else {
				this.topUpCredit = amount;
				// Set up credit top-up mode in store
				let company = this.customersStore.companiesIds[this.company.customer_id];
				if(company) {
					this.counterStore.creditTopUpMode = true;
					this.counterStore.registryEditingCustomer = {...company, type: 'company'};
					this.paymentActive = true;
				} else {
					this.showNotification("generic-fail");
				}
			}
		},
		goToOrder(orderId) {
			if(orderId) {
				this.ordersStore.search = "id:"+orderId;
				this.ordersStore.showCompleted = true;
				this.ordersStore.filterCounter = true;
				this.ordersStore.filterDelivery = true;
				this.ordersStore.filterTakeaway = true;
				this.ordersStore.filterRooms = true;
				this.ordersStore.refreshOrders();
				this.$router.push("/ops/orders");

				this.valuesStore.forceCloseAllBottomSheets = true;
				setTimeout(() => {
					this.valuesStore.forceCloseAllBottomSheets = false;
				}, 1000);
			}
		},
		isOrderInCart(order) {
			return !!(this.cart.find(o => o.order_id === order.order_id));
		},
		isPersonInCart(person) {
			return !!(this.cartPeople.find(o => o.customer_id === person.customer_id));
		},
		addToCart(order) {
			let existing = this.cart.find(o => o.order_id === order.order_id);
			if(existing) {
				this.cart.splice(this.cart.indexOf(existing), 1);
			} else {
				this.cart.push({
					order_id: order.order_id,
					total: order.amount,
				});
			}
		},
		addToPeopleCart(person) {
			let existing = this.cartPeople.find(o => o.customer_id === person.customer_id);
			if(existing) {
				this.cartPeople.splice(this.cartPeople.indexOf(existing), 1);
			} else {
				this.cartPeople.push({
					customer_id: person.customer_id,
					total: person.debit,
				});
			}
		},
		togglingPopupPicker(open) {
			if(!open) {
				this.customersPickerActive = false;
			}
		},
		togglingPayment(open) {
			if(!open) {
				this.counterStore.creditTopUpMode = false;
				this.paymentActive = false;
			}
		},
		animateCreditIncrease(amount) {
			if (!this.company) return;
			this.animatingCredit = true;
			const start = this.company.credit || 0;
			const end = start + amount;
			const steps = 30; // Number of animation steps
			const duration = 1200; // Total duration in ms
			const stepValue = (end - start) / steps;
			let currentStep = 0;

			const interval = setInterval(() => {
				currentStep++;
				this.tempCreditValue = start + stepValue * currentStep;
				if (currentStep >= steps) {
					this.tempCreditValue = end;
					this.animatingCredit = false;
					if(this.company) {
						this.company.credit = end;
					}
					clearInterval(interval);
				}
			}, duration / steps);
		},
		refreshCustomer(callback) {
			API.init().getCustomer(this.userStore.currBusinessId, this.company.customer_id, 'company', r => {
				let updatedCompany = r && r.result === "OK" ? r.customer : null;
				updatedCompany = updatedCompany ? this.customersStore.normalizeCustomerCompany(updatedCompany) : null;
				if(updatedCompany) {
					let currentIndex = this.customersStore.customersCompanies.findIndex(c => c.customer_id === updatedCompany.customer_id);
					if(currentIndex !== -1) {
						this.customersStore.customersCompanies.splice(currentIndex, 1, updatedCompany);
					}
					let regCustomer = this.counterStore?.registryEditingCustomer;
					let selCustomer = this.counterStore?.selectedCustomer;
					if(regCustomer?.type === 'company' && regCustomer?.customer_id === updatedCompany.customer_id) {
						this.counterStore.registryEditingCustomer = {...updatedCompany, type: 'company'};
					}
					if(selCustomer?.type === 'company' && selCustomer?.customer_id === updatedCompany.customer_id) {
						this.counterStore.selectedCustomer = {...updatedCompany, type: 'company'};
					}
				}
				if(!this.sunmiStore.cashmaticPendingDismissal) {
					this.paymentActive = false;
				}
				this.activeAddCreditNumberEditor = false;
				this.counterStore.creditTopUpMode = false;
				// Refresh top-up history table if it's currently shown
				if(this.tabIndex === 3 && this.$refs['topups-table']) {
					this.$nextTick(() => {
						this.$refs['topups-table'].fetchData();
					});
				}
				callback && callback(r?.result === 'OK');
				this.showNotification(r?.result === 'OK' ? "payment-success" : "generic-fail");
			});
		},
		paymentTopUpCredit(type, total, callback) {
			// For Stripe/terminal payments, webhook will create the transaction
			// For non-Stripe payments, create the transaction now
			if(type === 'stripe') {
				this.animateCreditIncrease(total);
				this.refreshCustomer(callback);
			} else {
				API.init().topUpCustomerCredit(
					this.userStore.currBusinessId,
					total,
					this.company.customer_id,
					'company',
					type,
					(response) => {
						if(response && response.result === "OK") {
							this.animateCreditIncrease(total);
							this.refreshCustomer(callback);
						} else {
							if(!this.sunmiStore.cashmaticPendingDismissal) {
								this.paymentActive = false;
							}
							this.activeAddCreditNumberEditor = false;
							this.counterStore.creditTopUpMode = false;
							callback && callback();
							this.showNotification("generic-fail");
						}
					}
				);
			}
		},
		paymentDone(type, value, partialType, orderAssociatedId, itemsSplit, dutchPeople, discountOnTotal, discountPartial, appliedCoupons, printSingleItem, callback) {
			let isTopUp = this.activeAddCreditNumberEditor;
			if(isTopUp) {
				this.paymentTopUpCredit(type, this.topUpCredit, callback);
				return;
			}
			let invoiceData = {
				invoice_paid: true,
			};
			if(!!type && ["wire", "check"].includes(type)) {
				invoiceData.invoice_paid = this.counterStore.setInvoiceAsPaid;
			}
			if(this.counterStore.invoiceAdditionalData?.purchase_order) {
				invoiceData.purchase_order = this.counterStore.invoiceAdditionalData.purchase_order;
			}
			if(!invoiceData.invoice_paid && this.counterStore.invoiceAdditionalData?.payment_due_date) {
				invoiceData.payment_due_date = formatDateOnly(this.counterStore.invoiceAdditionalData.payment_due_date);
			}
			if(this.tabIndex === 0) {
				const total = this.cartTotal;
				if(this.sunmiStore.canLocalPrint && this.nativeStore.allowLocalReceiptPrint && this.userStore.currBusiness?.apiscontrino_id) this.sunmiStore.expectingFiscalPrint = true;
				API.init().payCustomersOrders(this.userStore.currBusinessId, this.cart.map(o => o.order_id), type, JSON.stringify(invoiceData), total, this.company.customer_id, "company", discountOnTotal, (response) => {
					if(!this.sunmiStore.cashmaticPendingDismissal) {
						this.paymentActive = false;
					}
					if(response && response.result && response.result === 'OK') {
						callback && callback(true);
						this.showNotification("payment-success");
						this.cart = [];
						this.$emit('toggling-popup', false);
					} else {
						callback && callback(false);
						this.showNotification(response?.details === 'insufficient_credit' ? 'error-low-credit' : "generic-fail");
					}
				});
			} else if(this.tabIndex === 1) {
				if(this.sunmiStore.canLocalPrint && this.nativeStore.allowLocalReceiptPrint && this.userStore.currBusiness?.apiscontrino_id) this.sunmiStore.expectingFiscalPrint = true;
				API.init().payCompanyAssociatesOrders(this.userStore.currBusinessId, this.cartPeopleOrderIds, type, JSON.stringify(invoiceData), this.cartPeopleRealTotal, this.company.customer_id, (response) => {
					if(!this.sunmiStore.cashmaticPendingDismissal) {
						this.paymentActive = false;
					}
					if(response && response.result && response.result === 'OK') {
						callback && callback(true);
						this.showNotification("payment-success");
						this.cartPeople = [];
						this.cartPeopleRealTotal = 0;
						this.cartPeopleOrderIds = [];
						this.$emit('toggling-popup', false);
					} else {
						callback && callback(false);
						let notificationName = 'generic-fail';
						notificationName = response?.details === 'customer_not_found' ? 'warning-customer-missing' : notificationName;
						notificationName = response?.details === 'insufficient_credit' ? 'error-low-credit' : notificationName;
						this.showNotification(notificationName);
					}
				});
			}

		},
		associateCustomer(customer) {

			API.init().associateCustomerToCompany(this.userStore.currBusinessId, this.company.customer_id, customer.customer_id, (response) => {
				if(response && response.result && response.result === "OK") {
					this.showNotification("generic-success");
					this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
					this.customersPickerActive = false;
				} else {
					if(response && response.details && response.details === "already_associated") {
						this.showNotification("associated-already");
					} else {
						this.showNotification("generic-fail");
					}
				}
			});
		},
		removeCustomerAssociation(person) {
			API.init().removeCustomerCompanyPerson(this.userStore.currBusinessId, this.company.customer_id, person.customer_id, (response) => {
				if(response && response.result && response.result === "OK") {
					this.showNotification("generic-success");
					this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
				} else {
					this.showNotification("generic-fail");
				}
			});
		},
		fetchFunctionCompanyOrdersPayments(filters, callback) {
			if(!!this.userStore.manualCode) {
				if(!filters) { filters = {} }
				filters.manual_code = this.userStore.manualCode;
			}
			return this.customersStore.getFilteredCompanyOrdersAndPayments(this.company.customer_id, filters, callback);
		},
		fetchFunctionCompanyPeople(filters, callback) {
			return this.customersStore.getFilteredCompanyPeople(this.company.customer_id, filters, callback);
		},
		fetchFunctionCompanyCreditTopups(filters, callback) {
			return this.customersStore.getFilteredCompanyCreditTopups(this.company.customer_id, filters, callback);
		},
		tabButtonAction() {
			if(this.tabIndex !== 2) {
				this.activeAddCreditNumberEditor = true;
			} else if(this.tabIndex === 2) {
				this.$refs['company-details'] && this.$refs['company-details'].updateCompany();
			}
		},
		openBottomPayment() {
			if(this.tabIndex === 0) {
				if(this.cartTotal > 0) {
					let company = this.customersStore.companiesIds[this.company.customer_id];
					if(company) {
						this.counterStore.registryEditingCustomer = {
							...company,
							type: 'company',
						};
						this.paymentActive = true;
					} else {
						this.showNotification("generic-fail");
						this.paymentActive = false;
					}
				}
			} else if(this.cartPeopleTotal > 0) {
				API.init().getCustomersOrdersTotal(this.userStore.currBusinessId, this.company.customer_id, this.cartPeople.map(o => o.customer_id), (response) => {
					if(response && response.result && response.result === 'OK' && response.total) {
						let company = this.customersStore.companiesIds[this.company.customer_id];
						if(company) {
							this.counterStore.registryEditingCustomer = {
								...company,
								type: 'company',
							};
						}
						this.cartPeopleRealTotal = response.total;
						this.cartPeopleOrderIds = response.orders;
						this.paymentActive = true;
					} else {
						this.showNotification("generic-fail");
					}
				});
			}
		},
		payAll() {

			API.init().getCustomersAllOrders(this.userStore.currBusinessId, this.company.customer_id, "company", (response) => {
				if(response && response.result && response.result === 'OK' && response.orders) {
					if(response.orders.length === 0) {
						this.showNotification("nothing-to-pay");
						return;
					}
					this.cart = response.orders.map(o => {
						return {
							order_id: Number(o.order_id),
							total: o.total ? Number(o.total) : 0,
						}
					});
					let company = this.customersStore.companiesIds[this.company.customer_id];
					if(company) {
						this.counterStore.registryEditingCustomer = {
							...company,
							type: 'company',
						};
						this.paymentActive = true;
					} else {
						this.showNotification("generic-fail");
						this.paymentActive = false;
					}
				} else {
					this.showNotification("generic-fail");
				}
			});

		},
		emitDeletedCompany(c) {
			this.$emit('deleted-company', c);
		},
		printCustomerCreditQr() {
			if(!this.company) {
				this.showNotification("generic-fail");
				return;
			}

			this.customersStore.printCustomerCreditQr(this.company.customer_id, 'company', (success, details) => {
				if(success) {
					this.showNotification("print-customer-credit-success");
				} else if(details === 'no_printers_found') {
					this.showNotification("no-printers-found");
				} else if(details === 'customer_not_found') {
					this.showNotification("warning-customer-missing");
				} else {
					this.showNotification("generic-fail");
				}
			});
		}
	},
	watch: {
		companyId(newValue, oldValue) {
			if(newValue !== oldValue) {
				if(newValue) {
					this.tabIndex = 0;
					this.customersPickerActive = false;
					this.paymentActive = false;
					this.toUpdate = false;
					this.cart = [];
				}
			}
		},
	}
}
</script>

<style scoped lang="scss">
:deep(.table-wrapper) {
	padding-top: 0;
	margin-top: 10px;
	.row-actions {
		padding: 10px 10px 0;
	}
}
.orders-container, .people-container {
	.card-container {
		box-shadow: none;
		&:deep(.card-header) {
			display: none;
		}
	}
}
.table-text {
	font-size: 12px;
}
.row-actions {
	gap: 8px;
}

.payment-intent {
	text-align: left;
	width: 100%;
	font-size: 12px;

	&.clickable {
		cursor: pointer;
		color: var(--color-primary);
		text-decoration: underline;
	}
}
.details-card {
	background-color: transparent;
	box-shadow: none;
	&:deep(.card-body) {
		padding: 10px 0;
	}
}
.sheet-heading {
	display: flex;
	flex-direction: column;
	gap: 10px;
	background-color: var(--color-bg-primary-2);
	border-radius: 13px;
	padding: 10px;
	margin-bottom: 14px;
	box-shadow: $box_shadow_inset;

	&-first-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
		width: 100%;

		.first-row-ctas {
			gap: 10px;
		}

		@media (max-width: 600px) {
			flex-wrap: wrap;
		}
	}

	.sheet-title {
		font-size: 18px;
		font-weight: bold;
		font-style: italic;
		width: calc(100% - 30px);
	}
	.print-icon-container {
		border: 1px solid var(--color-primary);
		padding: 10px;
		border-radius: 13px;
	}
	.edit-icon {
		margin-right: 10px;
		width: 18px;
		height: 18px;
	}
	.edit-icon, .print-icon {
		width: 20px;
		height: 20px;

		:deep(svg) {
			width: 100%;
			height: 100%;
			.fill {
				fill: var(--color-primary);
			}
			.stroke {
				stroke: var(--color-primary);
			}
		}
	}
	.edit-icon.active {
		:deep(svg) {
			.fill {
				fill: var(--color-secondary);
			}
			.stroke {
				stroke: var(--color-secondary);
			}
		}
	}

	.credit-display-container {
		gap: 10px;
	}
	.credit-display {
		background-color: var(--color-alpha-1);
		padding: 15px 10px;
		box-shadow: $box_shadow_inset;
		border-radius: 13px;
		max-width: calc(50% - 5px);
		cursor: pointer;

		@media (max-width: 600px) {
			padding: 15px 5px;
		}

		@media (max-width: 400px) {
			max-width: 100%;
		}

		&.debit {
			background-color: var(--color-display-alpha-red);
		}
		&.credit {
			transition: background-color 0.2s $transition .2s;
			background-color: var(--color-display-alpha-green);
			&.animating {
				background-color: rgba(var(--rgb-secondary), .4);
			}
		}

		p.balance-label {
			font-size: 14px;
		}
		p.balance-value {
			font-size: 24px;
		}
	}

}
</style>